import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { frontendUrl } from '../../../../environments/environment';
import { StreamService } from '../../../service/stream.service';

@Component({
  selector: 'app-generate-promolink',
  templateUrl: './generate-promolink.component.html',
  styleUrl: './generate-promolink.component.scss',
  standalone: false,

})
export class GeneratePromolinkComponent {
  promolink: string = ""
  linkcopied: boolean = false;
  readonly data = inject<any>(MAT_DIALOG_DATA);
  hideLoading: boolean = true;


  controlName: any;
  controlExpireDate: any;
  controlPromolink: any;
  controlSkipRegistration: any;
  controlId: any;
  controlCounter: any;
  controlCredits: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialogRef<GeneratePromolinkComponent>,
    private streamService: StreamService
  ) {

    this.controlName = fb.control('', Validators.required);
    this.controlExpireDate = fb.control('', Validators.required);
    this.controlPromolink = fb.control('');
    this.controlSkipRegistration = fb.control(false);
    this.controlId = fb.control(Math.random().toString(36).replace('0.', ''));
    this.controlCounter = fb.control(0);
    this.controlCredits = fb.control(0);


  }

  async generatePromolink() {

    console.log(this.controlCounter.value, this.controlCredits.value);


    if (!this.controlName.valid || !this.controlExpireDate.valid) return;

    this.promolink = `${frontendUrl}/promotion/${this.controlId.value}?n=${this.controlName.value}&exp=${this.controlExpireDate.value.replaceAll('-', '')}&c=${this.controlCounter.value}&cr=${this.controlCredits.value}&skip=${this.controlSkipRegistration.value ? '1' : '0'}`;
    this.controlPromolink.setValue(this.promolink)
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.promolink);
    this.linkcopied = true;
    setTimeout(() => {
      this.linkcopied = false;
    }, 5000);
  }

  downloadQrCode() {
    const qrCode = document.querySelector('canvas') as HTMLCanvasElement | null;
    if (!qrCode) return;

    const canvas = document.createElement('canvas');
    canvas.width = qrCode.clientWidth;
    canvas.height = qrCode.clientHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(qrCode, 0, 0, canvas.width, canvas.height);
    const a = document.createElement('a');
    a.href = canvas.toDataURL('image/png');

    a.download = `${this.controlName.value}.png`;
    a.click();
  }

  close() {
    this.dialog.close();
  }

  async savePromoLink() {
    this.hideLoading = false;
    let result = await this.streamService.savePromotionLink(
      this.controlId.value,
      this.controlName.value,
      this.controlExpireDate.value,
      this.data.id,
      'TRACK',
      this.controlCounter.value,
      this.controlSkipRegistration.value,
      this.controlCredits.value
    );
    this.hideLoading = true;
  }
}
